import React, { useState, useRef } from 'react';
import './GroupDeletionModal.css';
import Modal from '../Modal/Modal';
import ActionButtons from '../ActionButtons/ActionButtons';
import baseApi from '../../common/api/base';
import logComponent from '../../common/logComponent';

export default function GroupDeletionModal({ group, deleteGroup: propsDeleteGroup, hide }) {
  const [status, setStatus] = useState('initial');
  const [modalShouldExit, setModalShouldExit] = useState(false);
  const actionButtons = useRef(null);

  if (logComponent('GroupDeletionModal')) { console.debug('GroupDeletionModal render'); }


  const deleteGroup = () => {
    if (logComponent('GroupDeletionModal')) { console.debug('GroupDeletionModal deleteGroup'); }
    setStatus('pending');

    baseApi.Group.Id.delete(group.groupId)
      .then(
        result => {
          setStatus('success');
          propsDeleteGroup(group);
          startModalExit();
        },
        error => {
          setStatus('failure');
        }
      )
  }
  
  const startModalExit = () => {
    if (logComponent('GroupDeletionModal')) { console.debug('GroupDeletionModal startModalExit'); }
    setModalShouldExit(true);
  }


  return (
    <Modal isVisible={true} shouldExit={modalShouldExit} hide={hide} remainOnBackdropClick={true}>
      <div className="Group-Deletion-Modal">
        <h3 className="Group-Deletion-Modal__heading">Delete group</h3>
        <p className="Group-Deletion-Modal__warning">Are you sure you want to delete this group?</p>
        <label
          className="Group-Deletion-Modal__group-name-label"
          htmlFor="Group-Deletion-Modal__group-name">
          Group name
        </label>
        <p
          className="Group-Deletion-Modal__group-name"
          id="Group-Deletion-Modal__group-name">
          {group.name}
        </p>
        <p className="Group-Deletion-Modal__warning-explanation">
          Remember: you may change group names and modify membership.  Deleting a group cannot be undone.
        </p>
        <ActionButtons
          ref={ actionButtons }
          warningAction={deleteGroup}
          warningActionText="Yes, delete"
          cancel={startModalExit}
          cancelText="Cancel"
          currentStatus={status} />
      </div>
    </Modal>
  );
}